import { createReducer } from 'reduxsauce';
import update from 'immutability-helper';

import { ProfileTypes } from '../actions/profile.js';
import { defaultLanguage } from '../../helpers/constants.js';
import { defaultPackageName, defaultRegion } from '../../../server/helpers/constants.mjs';

const INITIAL_STATE = {
  firstName: { value: '' },
  lastName: { value: '' },
  phone: { value: '' },
  currentFirstName: { value: '' },
  currentLastName: { value: '' },
  currentPhone: { value: '' },
  language: defaultLanguage,
  delivery: {
    code1C: '',
    type: '',
    postOffice: '',
    addressLine: '',
    city: '',
    region: '',
  },
  isLoading: false,
  isUpdating: false,
  primaryRegion: defaultRegion,
  regionsList: [],
  errorMessage: '',
  successMessage: '',
  currency: 'UAH',
  packageName: defaultPackageName,
  packageNameTranslation: {},
  packagesAvailable: [],
  role: '',
  email: '',
  managerImgUrl: '',
  dealerId: '',
  managerId: '',
  managerInfo: {},
  showPrice: false,
};

const updateProfileField = (state = INITIAL_STATE, { field }) => update(state, {
  [field.name]: {
    value: { $set: field.value },
    error: { $set: field.error },
  },
});

const setProfileLanguageRequest = (state = INITIAL_STATE) => update(state, {
  errorMessage: { $set: '' },
});

const setPackageNameByDealerRequest = (state = INITIAL_STATE) => update(state, {
  isLoading: { $set: true },
  errorMessage: { $set: '' },
  successMessage: { $set: '' },
});

const setPackageNameByDealerSuccess = (state = INITIAL_STATE) => update(state, {
  isLoading: { $set: true },
  successMessage: { $set: 'successMessages.price-package-is-set' },
});

const getUserProfileRequest = (state = INITIAL_STATE) => update(state, {
  isLoading: { $set: true },
  errorMessage: { $set: '' },
});

const getUserProfileSuccess = (state = INITIAL_STATE, { profile }) => update(state, {
  isLoading: { $set: false },
  errorMessage: { $set: '' },
  firstName: { value: { $set: profile?.firstName || '' } },
  lastName: { value: { $set: profile?.lastName || '' } },
  phone: { value: { $set: profile?.phone || '' } },
  currentFirstName: { value: { $set: profile?.firstName || '' } },
  currentLastName: { value: { $set: profile?.lastName || '' } },
  currentPhone: { value: { $set: profile?.phone || '' } },
  language: { $set: profile?.language || defaultLanguage },
  primaryRegion: { $set: profile?.primaryRegion || defaultRegion },
  regionsList: { $set: profile?.regionsList || [] },
  delivery: { $set: profile?.delivery || {} },
  packageName: { $set: profile?.packageName || defaultPackageName },
  packageNameTranslation: { $set: profile?.packageNameTranslation || {} },
  currency: { $set: profile?.currency || '' },
  packagesAvailable: { $set: profile?.packagesAvailable || [] },
  role: { $set: profile?.role || '' },
  email: { $set: profile?.email || '' },
  managerImgUrl: { $set: profile?.managerImgUrl || '' },
  dealerId: { $set: profile?.dealerId || '' },
  managerId: { $set: profile?.managerId || '' },
  managerInfo: { $set: profile?.managerInfo || {} },
  showPrice: { $set: profile?.showPrice || false },
});

const getUserProfileFailure = (state = INITIAL_STATE, { errorMessage }) => update(state, {
  isLoading: { $set: false },
  errorMessage: { $set: errorMessage },
});


const submitProfileFormRequest = (state = INITIAL_STATE) => update(state, {
  isUpdating: { $set: true },
  errorMessage: { $set: '' },
});

const submitProfileFormSuccess = (state = INITIAL_STATE) => update(state, {
  isUpdating: { $set: false },
  errorMessage: { $set: '' },
});

const submitProfileFormFailure = (state = INITIAL_STATE, { errorMessage }) => update(state, {
  isUpdating: { $set: false },
  errorMessage: { $set: errorMessage },
});

const setProfileSuccessMessage = (state = INITIAL_STATE, { successMessage }) => update(state, {
  successMessage: { $set: successMessage },
});

const clearProfileSuccessMessage = (state = INITIAL_STATE) => update(state, {
  successMessage: { $set: '' },
});

export default createReducer(INITIAL_STATE, {
  [ProfileTypes.UPDATE_PROFILE_FIELD]: updateProfileField,
  [ProfileTypes.SET_PROFILE_LANGUAGE_REQUEST]: setProfileLanguageRequest,
  [ProfileTypes.SET_PACKAGE_NAME_BY_DEALER_REQUEST]: setPackageNameByDealerRequest,
  [ProfileTypes.SET_PACKAGE_NAME_BY_DEALER_SUCCESS]: setPackageNameByDealerSuccess,
  [ProfileTypes.GET_USER_PROFILE_REQUEST]: getUserProfileRequest,
  [ProfileTypes.GET_USER_PROFILE_SUCCESS]: getUserProfileSuccess,
  [ProfileTypes.GET_USER_PROFILE_FAILURE]: getUserProfileFailure,
  [ProfileTypes.SUBMIT_PROFILE_FORM_REQUEST]: submitProfileFormRequest,
  [ProfileTypes.SUBMIT_PROFILE_FORM_SUCCESS]: submitProfileFormSuccess,
  [ProfileTypes.SUBMIT_PROFILE_FORM_FAILURE]: submitProfileFormFailure,
  [ProfileTypes.SET_PROFILE_SUCCESS_MESSAGE]: setProfileSuccessMessage,
  [ProfileTypes.CLEAR_PROFILE_SUCCESS_MESSAGE]: clearProfileSuccessMessage,
});
